import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_DOCUMENT } from './../../../const/icons';

import { COMP_BUTTON_DOCUMENT } from './../../../const/components';

import { FIELD_DOCUMENT_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Document = (editor, options:any = {}) => {

  (FIELD_DOCUMENT_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_DOCUMENT,
    displayIcon: ICON_BUTTON_DOCUMENT,
    model: {
      defaults: { ...Defaults,
        name: 'Document',
        traits: [ ...Traits, FIELD_DOCUMENT_SELECTOR]
      }
    }
  });
}